import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import AresNavBar from '../../Layout/NavBar/NavBar';
import SideBar from '../../Layout/SideBar/SideBar';
import DataTableExtensions from 'react-data-table-component-extensions';
import { useHistory } from 'react-router-dom'
import client from "../../../services/Api";
import moment from 'moment';
import './index.css'
import { Button } from 'react-bootstrap';
import { ModalManager } from 'react-dynamic-modal/lib/Modal';
import DisableUserModal from '../DisableUserModal';
import { useAuth } from '../../../providers/auth';


function EnterpriseScreen() {
    const [loading, setLoading] = useState(true);
    const [enterprises, setEnterprises] = useState([]);
    const [tableData, setTableData] = useState(null);
    const history = useHistory();
    const { user } = useAuth();

    useEffect(() => {
        init()
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const columns = [
        {
            name: 'Nome',
            selector: 'name',
            sortable: false,
            width: '15%',
        },
        {
            name: 'Data de criação',
            format: row => moment.utc(row.created_at).local().format('DD/MM/YYYY HH:mm:ss'),
            selector: 'created_at',
            sortable: false,
            width: '12%',
        },
        {
            name: 'Dispositivos vinculados',
            selector: 'available_devices',
            format: row => row.available_devices != null ? row.available_devices.length : "--",
            sortable: false,
            width: '12%',
        },
        {
            name: 'Usuários vinculados',
            selector: 'available_devices',
            format: row => row.available_devices != null ? row.users.length : "--",
            sortable: false,
            width: '12%',
        },
        {
            cell: (row) =>
                <div className="actions">
                    <button className="add-beacon edit-beacon" onClick={() =>
                        history.push(`/enterprise-users?id=${row._id}`)
                    }>
                        Visualizar Usuários
                  </button>

                    <button className="add-beacon edit-beacon" onClick={() =>
                        history.push(`/add-beacons?id=${row._id}&user_id=${row.userOwner}&numDevices=${row.available_devices.length}`)
                    }>
                        Dispositivos
                  </button>

                    <button className="add-beacon edit-beacon" onClick={() => openDisableUserModal(row._id)}>
                        Desativar
                  </button>

                </div>
            ,
        }
    ];

    function openDisableUserModal(id) {
        ModalManager.open(<DisableUserModal client_id={id} userType={user.profile._id} />)
    }

    function renderLoading() {
        return (
            <div className="center-page">
                <Spinner animation="border" />
            </div>
        )
    }

    async function init() {
        setLoading(true);
        const response = await getEnterprises();
        if (response.data.length > 0) {
            const data = response.data;
            data.map((item) => {
                item.users.map((user) => {
                    if (user.isOwner)
                        return item.userOwner = user.id;
                });
            });
            setEnterprises(data);
            setTableData({
                data,
                columns
            })
        }
        setLoading(false);
    }

    async function getEnterprises() {
        try {
            const response = await client.get('/api/client-all');
            return response;
        } catch (e) {
            console.log(e);
        }
        return null;
    }

    return (
        <div className="Enterprise sidenav-margin">
            <AresNavBar />
            <SideBar />
            <div className="content">
                <div>
                    <div className="container-header">
                        <h1>Empresas</h1>
                    </div>

                </div>
                <div className="action">
                    <Button variant="primary" type="submit" onClick={() =>
                        history.push('/register-enterprise')
                    }>
                        Cadastrar Nova Empresa
                    </Button>
                </div>
                {loading ?
                    renderLoading()
                    :
                    <div>
                        <div className="beacon-table">
                            <DataTableExtensions
                                {...tableData}
                                filterPlaceholder="Pesquisar Empresas"
                                print={false}>
                                <DataTable
                                    columns={columns}
                                    data={enterprises}
                                    noDataComponent={
                                        <span>Nada encontrado...</span>
                                    }
                                    pagination={true}
                                />
                            </DataTableExtensions>
                        </div>
                    </div>
                }
            </div>
        </div>

    );
}

export default EnterpriseScreen;
